export enum Condition {
    New = 'Nou',
    Excellent = 'Excelent',
    VeryGood = 'Foarte bună',
    Good = 'Buna',
    Reasonable = 'Rezonabil'
}
